<script lang="ts" setup>
/* eslint-disable vue/no-v-html */
export interface PagebuilderYoutubeProps {
    data: {
        youtube_url: string
    }
}
const props = defineProps<PagebuilderYoutubeProps>()
</script>
<template>
  <div class="ratio ratio-16x9 rounded overflow-hidden">
    <iframe
      width="560"
      height="315"
      :src="
        props.data.youtube_url?.replace(
          'youtu.be/',
          'youtube.com/embed/'
        )
      "
      title="Prehrávač videa YouTube"
      frameborder="0"
      allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture"
      allowfullscreen
      loading="lazy"
    />
  </div>
</template>
